import { Component, OnInit } from '@angular/core';
import { SelectItem, LazyLoadEvent, Message, ConfirmationService } from 'primeng/api';
import { Feedback } from '../../../../models/inModels/feedbackModel';
import { Router } from '@angular/router';
import { FeedbackService } from '../../../../services/user/feedback.service';

@Component({
	selector: 'app-manage-feedback',
	templateUrl: './manage-feedback.component.html',
	styleUrls: ['./manage-feedback.component.css']
})
export class ManageFeedbackComponent {
	feedback: Feedback[];
	rows: SelectItem[];
	selectedRows: number;
	filteredRecords: number;
	rowEvent: LazyLoadEvent;
	loading: boolean;
	totalRecords: number;
	error: Message[];
	user: any;

	constructor(
		private feedbackService: FeedbackService,
		private router: Router,
		private confirmationService: ConfirmationService) {
		this.loading = true;
		this.rows = [];
		this.rows.push({ label: '10', value: 10 });
		this.rows.push({ label: '25', value: 25 });
		this.rows.push({ label: '50', value: 50 });
		this.selectedRows = 10;
	}

	changeRows(event): void {
		this.loadFeedback(this.rowEvent);
	}
	

	loadFeedback(event: LazyLoadEvent): void {
		this.loading = true;
		event.rows = this.selectedRows;
		this.rowEvent = event;
		this.feedbackService.search(event).then(
			dataPager => {
				this.feedback = dataPager.Data;
				this.filteredRecords = dataPager.FilteredRecords;
				this.totalRecords = dataPager.TotalRecords;
				this.loading = false;
			},
			error => {
				this.loading = false;
				console.log(error);
				this.feedback = [];
				this.totalRecords = 0;
				this.filteredRecords = 0;
				this.error = [];
				this.error.push({ severity: 'error', summary: 'Error', detail: error });
			}
		);
	}

	delete(feedback: Feedback) {
		console.log(feedback);
		this.confirmationService.confirm({
			message: `Are you sure you want to delete this feedback?`,
			header: 'Confirmation',
			icon: 'fa fa-trash-o',
			accept: () => {
				this.loading = true;
				this.feedbackService.delete(feedback.Id).then(
					result => {
						this.loading = false;
						this.loadFeedback(this.rowEvent);
					},
					error => {
						this.loading = false;
						this.error = [];
						this.error.push({ severity: 'error', summary: 'Error', detail: error });
					}
					)
			}
			})
	}

}



// WEBPACK FOOTER //
// ./src/app/components/feedback/manage/manage-feedback/manage-feedback.component.ts